import { AbstractControl, ValidatorFn } from '@angular/forms';

export function requiredConditionalValidator(required: boolean): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!required) {
      return null;
    }

    const value = control.value;

    if (value === null || value === undefined || value === '' || (Array.isArray(value) && value.length == 0)) {
      return { required: true };
    }

    return null;
  };
}

export function requiredOthers(flag_others_option: boolean): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!flag_others_option) {
      return null;
    }
    
    const value = control.value;

    if (Array.isArray(value) && value.some(v => v.includes('[Other]'))) {
      const otherValue = value.find(v => v.includes('[Other]'));
      if (otherValue && otherValue.replace('[Other]', '').trim() !== '') {
        return null;
      }
      return { required: true };
    }

    return null;
  };
}